import { initSubRoutes } from '../../utils/router';

const RoutesDeconnexion = initSubRoutes({
    route: '/deconnexion',
    subroutes: {},
    nom: 'Déconnexion',
});

export default RoutesDeconnexion;
